<script>
    export default {
        data() {
            return {
                step: 0,
                email: "",
                token: "",
                password: "",
                backendUrl: "/api/jsonws/otp.onetimepassword/request-otp/",
                error: "",

                busy: false,
                hasError: false,

                showMailLogin: true,
                canLoginWithOtp: false,

                formDataFieldNameLogin: '_com_liferay_login_web_portlet_LoginPortlet_login',
                formDataFieldNamePassword: '_com_liferay_login_web_portlet_LoginPortlet_password',
            }
        },

        computed: {
            /**
             * Reads the login URL for the default login.
             * @returns {string}
             */
            loginUrl() {
                // console.log("Login.vue: computed loginUrl " + window.klv.loginUrl);
                return window.klv.loginUrl;
            },

            /**
             * Reads the FB auth url.
             * @returns {*}
             */
            facebookAuthUrl() {
                return window.klv.facebookAuthURL;
            },

            /**
             * Did an error in the backend occur?
             * @returns {boolean}
             */
            loginErrorOccurred() {
                return window.klv.loginError;
            },
        },

        methods: {
            /**
             * Sends a request to the backend and checks what login methods for the user are
             * available. If OTP is forced we directly present the user the token field.
             */
            requestLogin() {
                if (this.busy) {
                    return;
                }

                this.hasError = false;
                this.errors.clear();

                this.busy = true;

                this.$validator.validate('email').then(result => {
                    if (result) {
                        Liferay.Service(
                            '/otp.onetimepassword/request-login',
                            {
                                mailAddress: this.email,
                            },
                            response => {
                                response = JSON.parse(response);
                                this.interpretResponse(response);

                                this.busy = false;
                            }
                        );
                    } else {
                        this.busy = false;
                    }
                });
            },

            /**
             * Request an OTP for the user and present him/her the token field.
             */
            requestOTP() {
                this.busy = true;

                Liferay.Service(
                    '/otp.onetimepassword/request-otp',
                    {
                        mailAddress: this.email,
                    },
                    response => {
                        response = JSON.parse(response);
                        this.interpretResponse(response);

                        this.busy = false;
                    }
                );
            },

            /**
             * Submit the default login.
             */
            submitLoginForm() {
                this.busy = true;
                this.$refs.loginForm.submit();
            },

            /**
             * Submit the default login with a token as the password.
             */
            submitTokenForm() {
                this.busy = true;
                this.$refs.tokenForm.submit();
            },

            /**
             * Interpret the server responses.
             * We can't rely on http status codes as the Liferay Backend always sends 200 🤦‍
             * @param {Object} response - A JSON object
             */
            interpretResponse(response) {
                if (!response || !response.status || response.status === 'ERROR') {
                    this.hasError = true;

                    if (response.error) {
                        if (response.error === 'USER_UNKNOWN') {
                            this.error = 'Wir konnten keinen Benutzer mit dieser E-Mail-Adresse finden!';
                            return;
                        }

                        if (response.error === 'NO_PHONE_NUMBER') {
                            this.error = 'Wir konnten keinen Token senden da keine Telefonnummer angegeben wurde! Bitte loggen Sie sich mit Ihrem Passwort ein.';
                            return;
                        }

                        if (response.error === 'OTP_ERROR') {
                            this.error = 'Wir konnten keinen Token senden! Bitte setzen Sie sich mit der KLV in Verbindung!';
                            return;
                        }
                    }

                    this.error = response.error || 'Ein unbekannter Fehler ist aufgetreten! Bitten kontaktieren Sie die KLV.';

                    return;
                }

                if (response.status === 'OTP_SENT') {
                    this.step = 2;
                    this.canLoginWithOtp = true;

                    return;
                }

                if (response.status === 'OTP_OPTIONAL') {
                    this.step = 1;
                    this.canLoginWithOtp = true;

                    return;
                }

                if (response.status === 'NO_OTP') {
                    this.step = 1;
                    this.canLoginWithOtp = false;

                    return;
                }
            },

            /**
             * Opens a popup window with the facebook login.
             */
            handleFacebookLogin() {
                console.log(this.facebookAuthUrl);

                const facebookConnectLoginWindow = window.open(
                    this.facebookAuthUrl,
                    'facebook',
                    'align=center,directories=no,height=560,location=no,menubar=no,resizable=yes,scrollbars=yes,status=no,toolbar=no,width=1000',
                );
                facebookConnectLoginWindow.focus();
            },
        }
    }
</script>

<template>
    <div class="klv-login">
        <p class="info is-danger" v-if="loginErrorOccurred">
            Anmeldung fehlgeschlagen!
        </p>

        <p class="info is-danger" v-if="hasError">
            {{ error }}
        </p>

        <template v-if="step === 0">
            <p class="intro">
                Bitte melden Sie sich an um fortzufahren:
            </p>
            <div class="field">
                <label class="label" for="email">
                    E-Mail-Adresse
                </label>
                <div class="control has-icons-left">
                    <input id="error"
                           type="email"
                           class="input"
                           v-model="email"
                           v-validate="'required|email'"
                           data-vv-name="email"
                           placeholder="beispiel@klv.at"
                           @keydown.enter.prevent="requestLogin"
                           v-autofocus
                    />
                    <span class="icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
                            <g fill="none" fill-rule="evenodd" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.375" transform="translate(1 4)">
                                <path d="M1.750001,14.1041732 C0.990615724,14.1041732 0.3750005,13.488558 0.3750005,12.7291727 L0.3750005,1.72916875 C0.3750005,0.969783474 0.990615724,0.35416825 1.750001,0.35416825 L18.250007,0.35416825 C19.0093923,0.35416825 19.6250075,0.969783474 19.6250075,1.72916875 L19.6250075,12.7291727 C19.6250075,13.488558 19.0093923,14.1041732 18.250007,14.1041732 L1.750001,14.1041732 Z"></path>
                                <path d="M19.3142574,0.8583351 L11.8489213,6.60033719 L11.8489214,6.60033711 C10.7589127,7.43885367 9.24109549,7.43885367 8.15108676,6.60033726 L0.68575071,0.8583351"></path>
                            </g>
                        </svg>
                    </span>
                    <p class="help is-danger" v-if="errors.has('email')">
                        E-Mail-Adresse ungültig
                    </p>
                </div>
            </div>
            <div class="field">
                <button class="button is-primary text-uppercase"
                        @click.prevent="requestLogin"
                        :disabled="busy"
                >
                    Anmelden
                </button>
            </div>
        </template>

        <template v-if="step === 1">
            <p class="intro">
                Bitte melden Sie sich mit Ihrem Passwort an.
<!--                <span v-if="canLoginWithOtp">
                    Sie haben auch die Möglichkeit, sich einen SMS-Token zuschicken zu lassen oder sich über Facebook anzumelden.
                </span>
                <span v-else>
                    Sie können sich auch über Facebook anmelden.
                </span>
-->
            </p>
            <form :action="loginUrl"
                  method="post"
                  ref="loginForm"
            >
                <input type="hidden" :name="formDataFieldNameLogin" v-model="email" />
                <div class="field">
                    <label class="label" for="password" v-if="canLoginWithOtp">
                        Passwort / Token
                    </label>
                    <label class="label" for="password" v-else>
                        Passwort
                    </label>
                    <div class="control has-icons-left">
                        <input id="password"
                               :name="formDataFieldNamePassword"
                               type="password"
                               class="input"
                               v-model="password"
                               ref="passwordInput"
                               placeholder="Ihr Passwort"
                               v-autofocus
                        />
                        <span class="icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
                                <g fill="none" fill-rule="evenodd" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.375" transform="translate(3)">
                                    <path d="M1.81250175,21.3125078 C1.05311647,21.3125078 0.43750125,20.6968925 0.43750125,19.9375032 L0.43750125,10.3125037 C0.43750125,9.55311847 1.05311647,8.93750325 1.81250175,8.93750325 L14.1875063,8.93750325 C14.9468915,8.93750325 15.5625068,9.55311847 15.5625068,10.3125037 L15.5625068,19.9375072 C15.5625068,20.6968925 14.9468915,21.3125078 14.1875063,21.3125078 L1.81250175,21.3125078 Z"></path>
                                    <path d="M3.18750225 8.93750398L3.18750225 5.500002 3.18750225 5.50000273C3.18750185 2.84213593 5.34212803.687500977 8.000004.687500977 10.6578708.687500575 12.8125058 2.84212676 12.8125058 5.50000273 12.8125058 5.50000273 12.8125058 5.50000273 12.8125058 5.50000273L12.8125058 8.93750398M8.000004 14.4375052L8.00000398 14.4375052C7.81015583 14.4375053 7.65625386 14.5914072 7.65625386 14.7812554 7.65625387 14.9711035 7.81015583 15.1250055 8.00000398 15.1250055 8.18985214 15.1250055 8.34375411 14.9711035 8.34375411 14.7812554L8.34375411 14.7812544C8.34426049 14.5919131 8.19117947 14.4380121 8.00183915 14.4375052 8.00122723 14.4375035 8.0006153 14.4375035 8.00000338 14.4375052L8.00000338 14.4375052"></path>
                                </g>
                            </svg>
                        </span>
                    </div>
                </div>
                <div class="field">
                    <button class="button is-primary text-uppercase"
                            @click="submitLoginForm"
                            :disabled="busy"
                    >
                        Anmelden
                    </button>
                </div>
                <div class="field" v-if="canLoginWithOtp">
                    <button class="button is-primary"
                            @click.prevent="requestOTP"
                            :disabled="busy"
                    >
                        SMS-Token anfordern
                    </button>
                </div>
            </form>
            <!--
            <div class="field is-spacer text-center text-uppercase">
                - oder -
            </div>
            <div class="field">
                <button class="button is-outlined has-icon"
                        @click="handleFacebookLogin"
                >
                    <span class="icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19">
                            <path fill="#3367C5" d="M9,5.51396034 L5.86892729,5.51396034 L5.86892729,4.00583479 C5.86892729,3.2965012 6.30469514,3.13104281 6.61134659,3.13104281 C6.91799804,3.13104281 8.80339094,3.13104281 8.80339094,3.13104281 L8.80339094,0.0102916704 L5.62756766,8.8817842e-15 C2.74665797,8.8817842e-15 2.20084773,2.32591751 2.20084773,3.81583472 L2.20084773,5.51316867 L0,5.51316867 L0,8.67983649 L2.20084773,8.67983649 C2.20084773,12.8060047 2.20084773,18.1798399 2.20084773,18.1798399 L5.86892729,18.1798399 C5.86892729,18.1798399 5.86892729,12.7569213 5.86892729,8.67983649 L8.69408216,8.67983649 L9,5.51396034 Z"></path>
                        </svg>
                    </span>
                    Mit Facebook anmelden
                </button>
            </div>
            -->
        </template>

        <template v-if="step === 2">
            <p class="intro">
                Wir haben Ihnen einen Token per SMS zugeschickt. Bitte geben Sie diesen hier ein:
            </p>
            <form :action="loginUrl"
                  method="post"
                  ref="tokenForm"
            >
                <input type="hidden" :name="formDataFieldNameLogin" v-model="email" />
                <div class="field">
                    <label class="label" for="token">
                        Token
                    </label>
                    <div class="control has-icons-left">
                        <input id="token"
                               :name="formDataFieldNamePassword"
                               type="password"
                               class="input"
                               v-model="password"
                               ref="tokenInput"
                               placeholder="Ihr SMS-Token"
                               v-autofocus
                        />
                        <span class="icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
                                <g fill="none" fill-rule="evenodd" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.375">
                                    <path d="M11.7498376,13.3072548 L14.0827551,10.9743373 L15.6887557,11.4051708 L15.6887556,11.4051708 C16.45772,11.6102521 17.247337,11.153135 17.4524229,10.3841687 C17.5173116,10.1408652 17.5173116,9.88480523 17.452423,9.64150256 L17.0215895,8.03550198 L17.7402564,7.31683505 L19.346257,7.74766854 L19.346257,7.74766853 C20.1145064,7.95346577 20.9041234,7.49750736 21.1099243,6.72926066 C21.1753173,6.48514491 21.1753173,6.22811973 21.1099243,5.98400398 L20.6800074,4.37800339 L20.6800075,4.37800335 C21.5234383,3.53431863 21.5232329,2.16664505 20.6795491,1.32321058 C19.8358643,0.479779768 18.4681908,0.479985102 17.6247563,1.32366899 L8.69550304,10.2529222 L8.69550308,10.2529223 C5.76700868,9.01128763 2.38645079,10.3787614 1.14481617,13.3072567 C-0.0968184492,16.2357511 1.2706553,19.616309 4.19915061,20.8579436 C7.12764501,22.0995782 10.5082029,20.7321045 11.7498375,17.8036092 C12.3590489,16.3667336 12.3590489,14.7441322 11.7498376,13.3072567 L11.7498376,13.3072548 Z"></path>
                                    <path d="M6.44679068,15.5559307 C7.00917872,16.1183187 7.00917872,17.0301329 6.44679068,17.5925172 C5.88440264,18.1549053 4.97258847,18.1549053 4.4102041,17.5925172 C3.84781607,17.0301292 3.84781607,16.118315 4.4102041,15.5559307 C4.97259214,14.9935426 5.88440631,14.9935426 6.44679068,15.5559307"></path>
                                </g>
                            </svg>

                        </span>
                    </div>
                </div>
                <div class="field">
                    <button class="button is-primary text-uppercase"
                            @click="submitTokenForm"
                            :disabled="busy"
                    >
                        Anmelden
                    </button>
                </div>
            </form>
        </template>
    </div>
</template>
